module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v("CHAPTER 1")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('img', {
    attrs: {
      "alt": "ship",
      "src": "image/ship.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("breeze from the southeast rippled the black water")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("of")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tongu")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Harbor")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("only")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("sound")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("was")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("muffled")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("clunk")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("of")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("oarlocks")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("quiet")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("dipping")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("of")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("oar")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("blades")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("as")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("rowed")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("us")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("toward")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(".")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("was")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("after")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("midnight")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("looked")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("around")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("at")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("silhouettes")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("of")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("other")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("boats")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("moored")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("darkness,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("hoped")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("their")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("crews")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("were")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("asleep,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("or")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("drunk,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("or")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("both.")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tanya")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("sat")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("behind")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("me")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("bow")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("of")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("skiff")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Lloyd")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("stern,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("each")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("of")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("us")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("wrapped")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("our")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("own")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("silent")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("thoughts,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("as")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("sailors")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("are")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("wont")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("do")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("on")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("eve")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("of")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("departure.")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It was a short row and I shipped the oars and glided alongside")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the sloop. Without a word, we threw our bags over the rail")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and climbed aboard.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I hadn’t cleaned up since the ransacking and ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("was a mess, not at all ready for sea. We stuffed the gear strewn about the cockpit back into the lockers, hoisted the skiff aboard and Lloyd and Tanya went forward to set the mains’l. The halyard blocks squealed and the sheet clanged on the traveler as the mains’l luffed. I glanced again at the other boats.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Set the stays’l and back it to starboard,” I whispered.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Speak English,” Tanya said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Take the stops off that sail,” I said, pointing to the stays’l, “and hoist it. After that, push the boom out to starboard.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Lloyd and ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tanya ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("looked aloft in the darkness, trying to figure out which halyard was which. She found it first and hoisted the little sail hand over hand. Lloyd leaned on the boom to back the sail, forcing ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("’s")]), _c('span', {
    staticClass: "ORIM-Ital"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("bow ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("away ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("from the wind. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tanya ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("untied the mooring pennant and looked back at me.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Let her go.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She dropped the heavy line over the bow and we were free.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Set the jib.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Again Tanya found the halyard first and hoisted the sail.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Once the jib was drawing, ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("heeled over and the rigging creaked, settling into its timeworn grooves, and the stays hummed with tension. The sloop met the chop and the lee bow threw back a little ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("spray, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("glowing white in the darkness. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tanya ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("came aft and sat in the cockpit, ran her fingers through my ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("hair. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She was flushed and breathing hard from the exertion of setting sail. I put my arm around her waist.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Are you going to tack, Casanova, or run us right into Tongu Shipyard?” Lloyd called from the foredeck.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("put")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("helm")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("over")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("boat")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("responded")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("well,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("rounding")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and filling ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("away ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("on the other tack. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("skirted the crowded wharves of the shipyard, the crews of the long-liners asleep, and the workshops and slipways quiet. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tanya ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("snuggled up close, rested her head on my ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("shoulder.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Will you guys get a room, for Chrissake,” Lloyd said, and Tanya looked up and smiled and, then, I smiled too.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Lloyd sat down with his feet hanging over the lee rail. He lit a cigarette and the larger ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("waves ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("washed over his feet as ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("danced")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("across")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("night-dark")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("harbor")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("on")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("her")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("way")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("sea.")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("took")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("several tacks to beat to windward out of the deep basin of ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tongu Harbor, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and when the moon set we were guided only by the bright lights of the canneries and the few lights of the villages. I kept ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("away ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("from the land and hoped our sails were unseen in the larger darkness. ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("began to rise and fall to the groundswell as we made our ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("way ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("toward open ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("water. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Lloyd pulled his legs inboard, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tanya ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("leaned against the cabin trunk, and we fell silent, listening only to ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("’s")]), _c('span', {
    staticClass: "ORIM-Ital"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("conversation with the Pacific and with the trade wind in her")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("rigging.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The distant wail of sirens carried over the water and the lights of police cars flashed on the shore, as an ambulance raced down the harbor road toward Bu’ulita. Lloyd jumped up and banged his head on the boom, sat back down with his head in his hands, rocked back and forth.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Oh God,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tanya ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("coolly reached for the binoculars. She rested them on her drawn up knees and watched the lights flashing like toys in the distance.")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("seemed")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("like")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("every")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("cop")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tongu")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("wanted")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("on")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("action and they streamed down the road one after the other.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“They found him,” Lloyd said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Maybe he called them,” I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Or somebody saw us.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Chill out,” Tanya said. “It might not be about him at all.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("were nearly abeam of the American Pacific Hotel, and we watched as the cop cars disappeared around the ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("corner, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("waited to see if the lights would appear again on the far side of the ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("harbor. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The sirens were muted by the headland between us.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("think")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("they")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("stopped")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Bu’ulita,”")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("said")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tanya,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("still")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("looking")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("through the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("binoculars.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“See, I ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("told ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("you,” Lloyd said. “Can’t you make this thing go any faster?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("was already charging along like a pony in full gallop.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("She ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("is not a ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("thing")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(",” I said. “And she’s doing great.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“He, she, it; whatever. The Coast Guard boat probably goes twenty knots.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Nobody’s going to come chasing after us for days.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“They might when they find out about the collection money,” Lloyd said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tanya put down the binoculars. We both stared at him.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“That package I got from the house,” he said. “It’s six grand in small bills, from the church.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“What the hell were you thinking, Lloyd?” Tanya asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Don’t even start, princess. ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("You’re ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the precious cargo everybody’s going to be looking for.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“They’re")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("not")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("going")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("figure")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("out")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’m")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("gone")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘til")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("sometime")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("tomorrow and they won’t know I’m ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("with ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("you guys, even then. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("They’ll think ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I went to the beach or")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("something.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“And they won’t know the money’s missing ‘til Sunday,” Lloyd added.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“They’ll come after us when they come after us,” I said, “and we’ll be long gone.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("shouldered her way into a larger wave, sending spray over the bow and washing down the side deck. Her motion was ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("fluid ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and powerful for such a small boat. Spray from the bow wave ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("drifted ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("over the cockpit, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("wetting ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("our faces ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("with ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("salty")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("mist.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e12207a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Plumbelly3.vue
// module id = 72
// module chunks = 0